import '@/styles/globals.css'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'flowbite';
import Head from 'next/head';
import Layout from '../components/static/_layout'
import { Inter } from 'next/font/google'
import { useState } from 'react'
import React from "react";
import { useRouter } from 'next/router';
export const MyContext = React.createContext();

const inter = Inter({ subsets: ['latin'] })
const App = ({ Component, pageProps }) => {
  const router = useRouter();
  const { locale } = router;

  const [globalValue, setGlobalValue] = useState(1);
  const [isSelected, setIsSelected] = useState(false);
  const [priceLöschen, setpriceLöschen] = useState(200);
  const [selectedValue, setSelectedValue] = useState(0);

  const getOgLocale = (loc) => {
    switch (loc) {
      case 'fr': return 'fr_FR';
      case 'de': return 'de_DE';
      case 'es': return 'es_ES';
      default: return 'fr_FR';
    }
  };

  return (
    <MyContext.Provider value={{ globalValue, setGlobalValue, isSelected, setIsSelected ,priceLöschen , setpriceLöschen, selectedValue, setSelectedValue  }}>
        <Layout className={inter.className}>
            <style jsx global>{`
            html {
            font-family: ${inter.style.fontFamily};
            }
        `}</style>

        <Head>

            <link rel="icon" type="image/x-icon" href="/images/global/favicon-funfsterne.ico" />
            <meta charSet="UTF-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={`https://resenas123.es${locale === 'es' ? '' : `/${locale}`}`} />
            <meta property="og:locale" content={getOgLocale(locale)} />
            <meta property="og:type" content="article" />
            <meta property="og:url" content={`https://resenas123.es${router.asPath === '/' ? '' : router.asPath}`} />

            </Head>
                <Component {...pageProps} />
        </Layout>
    </MyContext.Provider>
  )
}




export default App



